import { render, staticRenderFns } from "./BtnResetar.vue?vue&type=template&id=23efe4fa"
import script from "./BtnResetar.vue?vue&type=script&lang=js"
export * from "./BtnResetar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports